import React from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import Textfield from '@atlaskit/textfield';
import { DisplayMode } from '../../RenderForm';
import { FieldDisabledWrapper as FieldDisabledWrapperNew, FieldDisabledWrapperOld, ViewWrapper } from '../common/questionWrappers';
export const ViewNumber = ({
  id,
  value,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    const FieldDisabledWrapper = getBooleanFF('platform.fix-disabled-style-in-form-fields_afsmu') ? FieldDisabledWrapperNew : FieldDisabledWrapperOld;
    return /*#__PURE__*/React.createElement(FieldDisabledWrapper, null, /*#__PURE__*/React.createElement(Textfield, {
      id: id,
      value: value,
      isReadOnly: true,
      width: "small"
    }));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value);
};